/**
 * Открытие палитры извне.
 *
 * Событием, а не стором: палитра ничего не хранит между показами, а знать
 * друг о друге таб-бару и ей незачем — она живёт в каркасе экрана.
 */
export const PALETTE_EVENT = 'tracker:palette'

export const openPalette = (): void => {
  window.dispatchEvent(new CustomEvent(PALETTE_EVENT))
}
